module.exports = __webpack_public_path__ + "img/ehic_ghic_info.c8d1797e.webp";